import { Component, Input, OnInit } from '@angular/core';
import { ImportCyclistsComponent } from '../../cyclists/import-cyclists/import-cyclists.component';

import { TechnicianService } from '../../../../../services/technician.service';
import { HelpersService } from '../../../../../services/helpers.service';
import moment from 'moment';

@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss'],
})
export class AvailabilityComponent implements OnInit {
  @Input() technicians;
  @Input() techniciansHidden;
  @Input() eventDates;

  public availability: any = {};
  public currencySymbol = 'R';
  public openPanel = false;
  public partner: any = {};
  public loaded: boolean = false;
  public screenWidth: number = 1024;
  public avatarSize: number = 0;

  constructor(
    public technicianService: TechnicianService,
    public helpersService: HelpersService,
  ) {
    this.partner = this.helpersService.getPartnerData();
    this.currencySymbol = this.partner.CurrencySymbol;
  }

  ngOnInit() {
    this.getTechnicianDateData();

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
    this.screenWidth = window.innerWidth;
  }

  getData() {
    if (this.loaded) {
      this.getTechnicianDateData();
    }
  }

  getTechnicianDateData() {
    var fromDate = this.eventDates[0];
    var toDate = this.eventDates[this.eventDates.length - 1];
    this.technicians = this.technicians.filter(
      (technician) => !this.techniciansHidden.includes(technician.id),
    );
    var technicians = this.technicians.map((x) => {
      return x.id;
    });
    this.technicianService
      .getTechniciansAvailabilityDateRange(
        this.helpersService.getPartnerId(),
        fromDate,
        toDate,
        technicians,
      )
      .subscribe((res) => {
        this.eventDates.forEach((eventDate: any) => {
          var date = moment(eventDate).format('YYYYMMDD');
          if (
            res.filter((x: any) => {
              return x.date === date;
            }).length > 0
          ) {
            var availability = res
              .filter((x: any) => {
                return x.date === date;
              })
              .map((x) => {
                return x.roundedAvailableTime;
              })
              .reduce((a, b) => {
                return a + b;
              });
            var workshopRevenue = res
              .filter((x: any) => {
                return x.date === date;
              })
              .map((x) => {
                return x.workshopRevenue;
              })
              .reduce((a, b) => {
                return a + b;
              });
            var dailyValueGoal = res
              .filter((x: any) => {
                return x.date === date;
              })
              .map((x) => {
                return x.dailyValueGoal;
              })
              .reduce((a, b) => {
                return a + b;
              });
            var totalWorkingHours = res
              .filter((x: any) => {
                return x.date === date;
              })
              .map((x) => {
                return x.workingHours;
              })
              .reduce((a, b) => {
                return a + b;
              });
            var totalLabour = res
              .filter((x: any) => {
                return x.date === date;
              })
              .map((x) => {
                return x.totalLabour;
              })
              .reduce((a, b) => {
                return a + b;
              });

            this.availability[eventDate] = {
              technicians: res.filter((x: any) => {
                return x.date === date;
              }),
              availability,
              workshopRevenue,
              totalWorkingHours,
              dailyValueGoal,
              totalLabour,
            };
          } else {
            this.availability[eventDate] = {
              technicians: res.filter((x: any) => {
                return x.date === date;
              }),
              availability: 0,
              workshopRevenue: 0,
              totalWorkingHours: 0,
              dailyValueGoal: 0,
              totalLabour: 0,
            };
          }
        });

        setTimeout(() => {
          var container = document.getElementsByClassName('date-container');
          if (container.length > 0) {
            var containerWidth = container[0]['offsetWidth'];
            var size = (containerWidth - 32) / this.technicians.length;
            this.avatarSize = size > 20 ? 20 : size;
          }
        }, 500);
      });
  }

  getAvailability(date) {
    return this.availability[date];
  }

  getFormattedDay(date) {
    return moment(date).format('ddd, DD MMM');
  }

  getTechnician(date, technicianID) {
    var technician = this.availability[date].technicians
      .filter((x) => {
        return x.id == technicianID;
      })
      .pop();
    return technician;
  }
}
